var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAddress = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 19,
  height: 18,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M9.738 1.086a6.03 6.03 0 0 1 6.033 6.149c0 3.647-5.443 9.289-5.674 9.528a.5.5 0 0 1-.717 0c-.232-.24-5.675-5.877-5.675-9.528a6.03 6.03 0 0 1 6.033-6.15m0 14.6c.5-.541 1.44-1.6 2.372-2.858 1.741-2.341 2.661-4.274 2.661-5.59a5.035 5.035 0 0 0-8.628-3.624 5.03 5.03 0 0 0-1.438 3.624c0 1.317.922 3.253 2.668 5.6a38 38 0 0 0 2.365 2.848"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M9.738 3.948a3.285 3.285 0 1 1 0 6.57 3.285 3.285 0 0 1 0-6.57m0 5.571a2.285 2.285 0 1 0 0-4.57 2.285 2.285 0 0 0 0 4.57"
})));
export { SvgAddress as ReactComponent };
export default "/_next/static/images/address.svg";